import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  addSign,
  deleteSign,
  filterSign,
  getPolicy,
  getSign,
  openPolicy,
  policyContent,
  updatePolicyData,
  viewSign,
} from "src/api";
import { Constant } from "src/lib/Constants";
import {
  ADD_SIGNATURE_ERROR,
  ADD_SIGNATURE_LOADING,
  ADD_SIGNATURE_SUCCESS,
  ALL_SIGNATURE_ERROR,
  ALL_SIGNATURE_LOADING,
  ALL_SIGNATURE_SUCCESS,
  DELETE_SIGNATURE_ERROR,
  DELETE_SIGNATURE_SUCCESS,
  GET_POLICY_ERROR,
  GET_POLICY_SUCCESS,
  GET_SIGNATURE_ERROR,
  GET_SIGNATURE_SUCCESS,
  OPEN_POLICY_ERROR,
  OPEN_POLICY_SUCCESS,
  POLICY_CONTENT_ERROR,
  POLICY_CONTENT_LOADING,
  POLICY_CONTENT_SUCCESS,
  UPDATE_POLICY_ERROR,
  UPDATE_POLICY_LOADING,
  UPDATE_POLICY_SUCCESS,
  VIEW_SIGNATURE_ERROR,
  VIEW_SIGNATURE_LOADING,
  VIEW_SIGNATURE_SUCCESS,
} from "src/redux/types";

function* hrFetch() {
  yield put({
    type: POLICY_CONTENT_LOADING,
    payload: true,
  });
  try {
    let res = yield call(policyContent);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: POLICY_CONTENT_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: POLICY_CONTENT_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* policyFetch() {
  // yield put({
  //   type: GET_POLICY_LOADING,
  //   payload: true,
  // });
  try {
    let res = yield call(getPolicy);
    let response = res.response.data;

    if (res.response.data.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: GET_POLICY_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: GET_POLICY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* updatePolicy(action) {
  yield put({
    type: UPDATE_POLICY_LOADING,
    payload: true,
  });
  try {
    let res = yield call(updatePolicyData, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: UPDATE_POLICY_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: UPDATE_POLICY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* pdfPolicy(action) {
  try {
    let res = yield call(openPolicy, action.payload);
    let response = res.response.data;
    if (res.response.status === 200) {
      yield put({
        type: OPEN_POLICY_SUCCESS,
        payload: response,
      });
    } else {
      yield put({
        type: OPEN_POLICY_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
// signature
function* signFetch() {
  // yield put({
  //   type: GET_POLICY_LOADING,
  //   payload: true,
  // });
  try {
    let res = yield call(getSign);
    let response = res.response.data;
    if (res.response.status === 200 || Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: GET_SIGNATURE_SUCCESS,
        payload: response,
      });
    } else {
      yield put({
        type: GET_SIGNATURE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* addSignature(action) {
  yield put({
    type: ADD_SIGNATURE_LOADING,
    payload: true,
  });
  try {
    let res = yield call(addSign, action.payload);
    let response = res.response.data;    
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: ADD_SIGNATURE_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: ADD_SIGNATURE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
  }
}

function* signatureDelete() {
  try {
    let res = yield call(deleteSign);
    let response = res.response.data;
    // console.log(response.message);
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      // console.log(response.message);
      yield put({
        type: DELETE_SIGNATURE_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: DELETE_SIGNATURE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVES_DELETE_ERROR,
    //   payload: error.toString(),
    // });
  }
}
function* allSignFetch(action) {
  yield put({
    type: ALL_SIGNATURE_LOADING,
    payload: true,
  });
  try {
    let res = yield call(filterSign, action.payload);
    let response = res.response.data;
    if (res.response.status === 200) {
      yield put({
        type: ALL_SIGNATURE_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: ALL_SIGNATURE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}


function* viewSignature(action) {
  yield put({
    type: VIEW_SIGNATURE_LOADING,
    payload: true,
  });
  try {
    let res = yield call(viewSign, action.payload);
    let response = res.response.data;  
    if (res?.response?.status !== 404 && res?.response?.status === 200 && res.response.data) {
      yield put({
        type: VIEW_SIGNATURE_SUCCESS,
        payload: response,
      });
    } else {
        const errorMessage =
        res?.response?.data?.message ||
        "Failed to fetch document.";
      yield put({
        type: VIEW_SIGNATURE_ERROR,
        payload: errorMessage,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

export function* hrSaga() {
  yield takeEvery("POLICY_CONTENT_ACTION", hrFetch);
  yield takeLatest("GET_POLICY_ACTION", policyFetch);
  yield takeLatest("UPDATE_POLICY_ACTION", updatePolicy);
  yield takeLatest("OPEN_POLICY_ACTION", pdfPolicy);
  yield takeLatest("ADD_SIGNATURE_ACTION", addSignature);
  yield takeLatest("DELETE_SIGNATURE_ACTION", signatureDelete);
  yield takeLatest("GET_SIGNATURE_ACTION", signFetch);
  yield takeLatest("ALL_SIGNATURE_ACTION", allSignFetch);
  yield takeLatest("VIEW_SIGNATURE_ACTION",viewSignature);
}
